module.exports = __webpack_public_path__ + "static/media/TakeATourButton.64a7ce96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/TakeATourButton.svg
// module id = 340
// module chunks = 0